"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalSelectFotoPrincipal = ModalSelectFotoPrincipal;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));

var _useMediaQuery = _interopRequireDefault(require("@mui/material/useMediaQuery"));

var _styles = require("@mui/styles");

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Transition = /*#__PURE__*/_react.default.forwardRef(function Transition(props, ref) {
  return (0, _react2.jsx)(_material.Slide, _extends({
    direction: "up",
    ref: ref
  }, props));
});

const useStyles = (0, _styles.makeStyles)(theme => ({
  dialog: {
    '& .MuiDialog-paperWidthSm': {
      "@media screen and (min-width: 600px)": {
        width: 550
      }
    }
  },
  appBar: {
    position: 'relative'
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1
  },
  imgGrid: {
    margin: 15,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: 24,
    "@media screen and (min-width: 600px)": {
      gridTemplateColumns: '1fr 1fr 1fr'
    }
  },
  imgWrapSelected: {
    overflow: 'hidden',
    height: 0,
    padding: '50% 0',
    position: 'relative',
    opacity: 0.8,
    outline: '5px dashed ' + theme.palette.secondary.main
  },
  imgWrap: {
    overflow: 'hidden',
    height: 0,
    padding: '50% 0',
    position: 'relative',
    "&:hover": {
      outline: '5px solid ' + theme.palette.secondary.main
    }
  },
  image: {
    cursor: 'pointer',
    minWidth: '100%',
    minHeight: '100%',
    maxWidth: '100%',
    position: 'absolute',
    top: 0,
    left: 0
  }
}));

function ModalSelectFotoPrincipal(props) {
  const [principal, setPrincipal] = (0, _react.useState)(props.fotoSelected);
  const theme = (0, _styles.useTheme)();
  const mobile = (0, _useMediaQuery.default)(theme.breakpoints.down('xs'));
  const classes = useStyles();
  const {
    open,
    openModal,
    guardar,
    fotos,
    titulo
  } = props;
  return (0, _react2.jsx)(_material.Dialog, {
    className: classes.dialog,
    fullScreen: mobile,
    open: open,
    onClose: () => openModal(false),
    TransitionComponent: Transition
  }, (0, _react2.jsx)(_material.AppBar, {
    className: classes.appBar
  }, (0, _react2.jsx)(_material.Toolbar, null, (0, _react2.jsx)(_material.IconButton, {
    edge: "start",
    color: "inherit",
    onClick: () => openModal(false),
    "aria-label": "close"
  }, (0, _react2.jsx)(_Close.default, null)), (0, _react2.jsx)(_material.Typography, {
    variant: "h6",
    className: classes.title
  }, titulo), (0, _react2.jsx)(_material.Button, {
    color: "inherit",
    onClick: () => guardar(principal)
  }, "Guardar"))), !fotos || !fotos.length ? (0, _react2.jsx)(_material.Typography, {
    variant: "subtitle2",
    style: {
      margin: '15px 0px 15px 0px',
      textAlign: 'center'
    }
  }, "No se encontro ninguna foto cargada") : (0, _react2.jsx)("div", {
    className: classes.imgGrid
  }, fotos.map(f => {
    return (0, _react2.jsx)("div", {
      className: principal && f.id == principal.id ? classes.imgWrapSelected : classes.imgWrap,
      key: f.id
    }, (0, _react2.jsx)("img", {
      onClick: () => setPrincipal(f),
      className: classes.image,
      src: f.url
    }));
  })));
}

var _default = ModalSelectFotoPrincipal;
exports.default = _default;